import React from 'react';
import { motion } from 'framer-motion';
import { FormAccessButton } from '../components/FormAccessButton';
import { LiveAccessButton } from '../components/LiveAccessButton';
import { event } from '../data/event';
import { seo } from '../data/seo';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
export function WebinarAccess() {
  useDocumentMeta();
  return <main className="flex h-[100dvh] w-full flex-col items-center overflow-hidden bg-canvas px-5 text-ink" data-id="element-33" data-mp="18b00jkl37wq6">
      <motion.div initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="flex w-full max-w-2xl flex-1 flex-col items-center justify-center" data-id="element-34" data-mp="13c6jxjai7pls">
        <div className="relative aspect-[2.2/1] w-full max-w-[min(440px,42vh*2.2)] overflow-hidden" data-id="element-35" data-mp="1d2i1i8n41xb5">
          <img src={event.eventLogo} alt="La Rentrée Touristique by CNT" width={1772} height={1772} fetchPriority="high" decoding="async" className="absolute left-1/2 top-1/2 w-[150%] max-w-none -translate-x-1/2 -translate-y-1/2" data-id="element-36" data-mp="1r1r6ec5v94zt" />
        </div>

        <h1 className="mt-4 text-center text-lg font-normal text-muted sm:mt-6 sm:text-xl" data-id="element-37" data-mp="1x9t0nd3xl6k7">
          <span className="sr-only" data-id="element-38" data-mp="228cltbapaebi">La Rentrée Touristique by CNT — </span>
          Bienvenue au{' '}
          <span className="font-serif text-2xl italic text-ink sm:text-3xl" data-id="element-39" data-mp="277yvxbv8feg3">troisième webinaire</span>
        </h1>

        <p className="sr-only" data-id="element-40" data-mp="2b8ivem3a2u5e">{seo.description}</p>

        <div className="mt-6 grid w-full gap-3 sm:mt-10 sm:grid-cols-2 sm:gap-4" data-id="element-41" data-mp="2b77qgiy3jgcp">
          <FormAccessButton href={event.formUrl} data-id="element-42" data-mp="2g0ssqn6q2whp" />
          <LiveAccessButton href={event.liveUrl} linkOpensAt={event.linkOpensAt} broadcastStart={event.broadcastStart} linkAvailability={event.linkAvailability} broadcastLabel={event.broadcastLabel} data-id="element-43" data-mp="2kzn9zkp1kczp" />
        </div>
      </motion.div>

      <footer className="flex w-full max-w-2xl items-center justify-center gap-3 border-t border-black/10 py-4 sm:py-5" data-id="element-44" data-mp="258mjcus4v66f">
        <span className="text-xs font-medium text-muted sm:text-sm" data-id="element-45" data-mp="20b4af4e48qyf">Organisé par</span>
        <img src={event.organizerLogo} alt="Confédération Nationale du Tourisme" width={910} height={770} decoding="async" className="h-12 w-auto rounded-lg bg-white px-2 py-1 sm:h-14" data-id="element-46" data-mp="2ez7c41l4lghf" />
      </footer>
    </main>;
}